import React from 'react';
import { getOrgTermsContent } from '../../../../../content/utils.js';
import PageHeader from '../../../PageHeader.js';
import BreadCrumbs from '../../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../../icons/ProjectBreadcrumbIcon.jsx';
import {
  ChangeStrategiesLink,
  ProjectLink,
  ProjectsLink,
} from '../../../../links/index.jsx';

const ChangeStrategyFormHeader = ({ project }) => {
  return (
    <PageHeader flex>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
        <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        <ChangeStrategiesLink projectId={project.id}>
          Change Strategy
        </ChangeStrategiesLink>
        <span>Edit Change Strategy</span>
      </BreadCrumbs>
    </PageHeader>
  );
};
export default ChangeStrategyFormHeader;
